import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { Session } from 'services';
import httpClient from 'utils/httpClient';

const REPORT_CC = (id: Number) => `/v2/teacher/unit/${id}/report-cc`;

export type reportCCBody = {
  id: number;
};

export type ReportCCResponse = {
  session: Session;
};

export const reportCC = ({ id }: reportCCBody) => {
  return httpClient.post<ReportCCResponse>(REPORT_CC(id), {});
};

export const useReportCC = (
  opts?: UseMutationOptions<
    AxiosResponse<ReportCCResponse>,
    AxiosError<any>,
    reportCCBody
  >,
) =>
  useMutation<
    AxiosResponse<ReportCCResponse>,
    AxiosError<any>,
    reportCCBody
  >(reportCC, opts);
